module.exports = __webpack_public_path__ + "static/media/Farouk_Grissom_headshot.8d53b8e0.jpg";